<template>
  <div id="imLinkUI" ref="imLinkUI" :class="['lnner', { hide: !show }]">
    <div class="top">
      <div class="line"></div>
    </div>
    <div class="userImgBox">
      <img class="userImg" :src="imRoom?.imLinkHead || defaultHead" alt="" />
    </div>
    <p class="fromText">
      <span class="userName">{{ imRoom && imRoom.imLinkName }}</span>{{ text }}
    </p>
    <div class="btnBox">
      <img class="left fl" :src="decline" alt="" @click.stop.prevent="unlisten" />
      <img
        class="right fr"
        ref="rightGo"
        :src="acepte"
        alt=""
        :data-href="acceptHref"
        @click.stop.prevent="readMsg($event)"
      />
    </div>
  </div>
</template>

<script>
import decline from '@/assets/img/common/decline@3x.png'
import acepte from '@/assets/img/common/acepte@3x.png'
import defaultHead from '@/assets/img/common/default-icon1.png'
import { imUrlApi } from '@/api/imiframe.js'
import { langText, appUI } from '@/utils/imTools.js'
import TIM from 'tim-js-sdk'
import { useImBusStore } from '@/stores/imBus'
import { storeToRefs } from 'pinia'

export default {
  name: 'ImLinkUI',
  setup() {
    const imBus = useImBusStore()
    const { timjs, imLinkShow, imiframeApi, logined, imRoom } = storeToRefs(imBus)
    return { imBus, timjs, imLinkShow, imiframeApi, logined, imRoom }
  },
  data() {
    return {
      decline,
      acepte,
      defaultHead,
      text: undefined,
      show: false
    }
  },
  computed: {
    acceptHref() {
      const room = this.imRoom
      if (!room) return ''
      return `account=${room.imLinkAccount}&scene=${room.imLinkScene}&name=${room.imLinkName}&roomid=${room.RoomId}&userid=${room.userId}&inviteid=${room.inviteID}&mediaType=${room.mediaType}`
    }
  },
  watch: {
    imLinkShow: {
      handler(val) {
        this.show = val
      },
      immediate: true
    },
    imRoom: {
      handler() {
        if (this.imRoom && this.imRoom.mediaType) {
          this.text =
            this.imRoom.mediaType == 1 ? langText('audioCallFor') : langText('videoCallFor')
        }
      },
      deep: true
    }
  },
  methods: {
    readMsg(event) {
      if (this.logined) {
        const url = event.currentTarget.dataset.href
        this.imBus.setImLinkShowState({ imLinkShow: false })
        const w = window.open(`${this.imiframeApi}?${url}`, 'view_window')
        w?.resizeTo(500, 500)
        w?.moveTo(200, 200)
      } else {
        this.imUrlCb()
      }
    },
    imUrlCb() {
      imUrlApi().then((res) => {
        const href = this.$refs.rightGo.dataset.href
        const judge = res.data.tmpUrl.indexOf('?')
        let url
        if (judge >= 0) {
          url = `${res.data.tmpUrl}&${href}`
        } else {
          url = `${res.data.tmpUrl}?${href}`
        }
        this.imBus.setImiframeApi(res.data.imdomain)
        this.imBus.setLogined()
        this.imBus.setImLinkShowState({ imLinkShow: false })
        const w = window.open(url, 'view_window')
        w?.resizeTo(500, 500)
        w?.moveTo(200, 200)
      })
    },
    unlisten() {
      if (this.imRoom.mediaType == 1) {
        this.SendCustomeMsg(
          'voiceCallReject',
          'audio-leave',
          this.imRoom.RoomId,
          null,
          this.imRoom.userId,
          this.imRoom.inviteID
        )
      } else {
        this.SendCustomeMsg(
          'videoCallReject',
          'video-leave',
          this.imRoom.RoomId,
          null,
          this.imRoom.userId,
          this.imRoom.inviteID
        )
      }
      this.imBus.setImLinkShowState({ imLinkShow: false })
    },
    SendCustomeMsg(sendText, actionType = '', extension, members, inviter, inviterid) {
      const ext = extension
      let actionTypeNum
      let roomId
      let inviteeList = []
      if (actionType.indexOf('video') > -1) {
        let notice = {}
        let call_type = 2
        let call_end
        let busy
        if (sendText == 'videoCallReject') {
          actionTypeNum = 4
          roomId = ext
          inviteeList = [this.imRoom.imLinkAccount]
          const userId = ext
          notice[userId] = userId
        }
        for (const val in notice) {
          const msg = this.timjs.createCustomMessage({
            to: String(val),
            conversationType: TIM.TYPES.CONV_C2C,
            payload: {
              data: appUI.mediaSend(
                sendText,
                actionType,
                String(ext),
                actionTypeNum,
                inviter,
                roomId,
                call_type,
                busy,
                call_end,
                inviteeList,
                inviterid
              ),
              description: actionType,
              extension: String(ext)
            }
          })
          this.sendMessage(
            msg,
            () => {
              console.log('------------video自定义消息成功')
            },
            (err) => {
              throw err
            }
          )
        }
      } else {
        let to
        const call_type = 1
        let call_end
        let busy
        if (sendText == 'voiceCallReject') {
          roomId = ext
          inviteeList = [this.imRoom.imLinkAccount]
          actionTypeNum = 4
          to = inviter
        }
        const msg = this.timjs.createCustomMessage({
          to: String(to),
          conversationType: TIM.TYPES.CONV_C2C,
          payload: {
            data: appUI.mediaSend(
              sendText,
              actionType,
              String(ext),
              actionTypeNum,
              inviter,
              roomId,
              call_type,
              busy,
              call_end,
              inviteeList,
              inviterid
            ),
            description: actionType,
            extension: String(ext)
          }
        })
        this.sendMessage(
          msg,
          () => {
            console.log('------------audio自定义消息成功')
          },
          (err) => {
            throw err
          }
        )
      }
    },
    sendMessage(msg, cbOk, cbErr) {
      this.timjs.sendMessage(msg).then(
        (res) => {
          if (cbOk) return cbOk(res.data.message)
        },
        () => {
          alert(langText('msgSendFail'))
          if (cbErr) cbErr()
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.hide {
  display: none !important;
}
#imLinkUI {
  width: 375px;
  height: 215px;
  background: #2a3131;
  border-radius: 10px 10px 0 0;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 999;
  padding: 0 20px;
  font-size: 0;
  .top {
    text-align: center;
    .line {
      width: 18px;
      height: 4px;
      border-radius: 4px;
      background: #a1a5a5;
      display: inline-block;
      margin-top: 8px;
    }
  }
  .userImgBox {
    text-align: center;
    .userImg {
      width: 45px;
      height: 45px;
      display: inline-block;
      margin: 17px 0;
      border-radius: 50%;
      padding: 7px;
      box-sizing: content-box;
      border: 1px solid rgba(255, 255, 255, 0.6);
    }
  }
  .fromText {
    margin-bottom: 18px;
    text-align: center;
    font-size: 14px;
    color: #cccccc;
  }
  .btnBox {
    img {
      width: 50px;
      height: 50px;
    }
    .left {
      margin-left: 30px;
      cursor: pointer;
    }
    .right {
      margin-right: 30px;
      cursor: pointer;
      float: right;
    }
  }
}
</style>
